import React from "react";
import { Link } from "react-router-dom";
import { HERO_IMAGE } from "@/data/site";

/**
 * The single, canonical OOS logo used EVERYWHERE on the site.
 * It is cropped directly from the hero image so it matches the logo shown in
 * the top-left of the hero page exactly (same design, colours and size).
 */
export default function Logo({ to = "/" }) {
  return (
    <Link to={to} aria-label="Online Office Solutions Co home" className="inline-block">
      <span
        role="img"
        aria-label="Online Office Solutions Co"
        className="block"
        style={{
          width: "196px",
          height: "62px",
          backgroundImage: `url(${HERO_IMAGE})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "1085px 608px",
          backgroundPosition: "-33px -9px",
        }}
      />
    </Link>
  );
}
